export const projects = [
  {
    title: "Social App",
    subtitle: "MERN Stack",
    description:
      "A social media web application where user can add/delete post,follow each other and comment on other post Upload/Update profile images",
    image: "./project-1.gif",
    link: "https://github.com/Slowgeek/Social-App",
  },
  {
    title: "Geeks Diary",
    subtitle: "MERN Stack",
    description:
      "A Progressive Web app which assist a learner to revise learned concept in just a few clicks. User can create notes with Tags and Codes with Syntax highlighting",
    image: "./project-2.gif",
    link: "https://github.com/Slowgeek/GeeksDiary",
  },
  {
    title: "Online classroom",
    subtitle: "React and SocketIo",
    description:
      "A Web app to create different subject , share assignment, test with students .Seperate dashboard/Login/Signup for teacher and students,Students and teacher can Chat with each other ",
    image: "./project-3.gif",
    link: "https://github.com/Slowgeek/Online-Classroom",
  },
  {
    title: "EduSmart",
    subtitle: "React and React three fiber",
    description:
      "With this application, we focus on solving the problem of visualization in online classes by using 3D, Augmented reality to give life-like simulations of various models and make the learning process more impactful and engaging.",
    image: "./project-4.gif",
    link: "https://github.com/Slowgeek/EduSmart",
  },
];

export const skills = [
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Express",
  "Node",
  "Mongodb",
  "Socket IO",
  "C++",
  "Tailwind",
];
